module.exports = __webpack_public_path__ + "img/solicitacoes.bbdf5bb3.svg";